import { toFormData } from "axios";
import server_api from "data/server_apis/server_api";

export const getVideos = () => {
  return server_api.get("/ads/video");
};
export const createVideo = (data) => {
  return server_api.postForm("/ads/video", toFormData(data));
};
export const deleteVideo = (id) => {
  return server_api.delete(`/ads/video/${id}`);
};

export const getImages = () => {
  return server_api.get("/ads/image");
};
export const createImage = (data) => {
  return server_api.postForm("/ads/image", toFormData(data));
};
export const deleteImage = (id) => {
  return server_api.delete(`/ads/image/${id}`);
};

export const getVideoAllocations = (m_id) => {
  return server_api.get(`/ads/video-allocation?machine=${m_id}`);
};
export const createVideoAllocation = (data) => {
  return server_api.postForm("/ads/video-allocation", toFormData(data));
};
export const deleteVideoAllocation = (id) => {
  return server_api.delete(`/ads/video-allocation/${id}`);
};
